import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'

const LOGIN_REQUEST = 'Auth/LOGIN_REQUEST'
const LOGIN_SUCCESS = 'Auth/LOGIN_SUCCESS'
const LOGIN_FAILURE = 'Auth/LOGIN_FAILURE'

const LOGOUT_REQUEST = 'Auth/LOGOUT_REQUEST'
const LOGOUT_SUCCESS = 'Auth/LOGOUT_SUCCESS'
const LOGOUT_FAILURE = 'Auth/LOGOUT_FAILURE'

const FETCH_CURRENT_USER_REQUEST = 'Auth/FETCH_CURRENT_USER_REQUEST'
const FETCH_CURRENT_USER_SUCCESS = 'Auth/FETCH_CURRENT_USER_SUCCESS'
const FETCH_CURRENT_USER_FAILURE = 'Auth/FETCH_CURRENT_USER_FAILURE'

const EDIT_USER_PROFILE_REQUEST = 'Auth/EDIT_USER_PROFILE_REQUEST'
const EDIT_USER_PROFILE_SUCCESS = 'Auth/EDIT_USER_PROFILE_SUCCESS'
const EDIT_USER_PROFILE_FAILURE = 'Auth/EDIT_USER_PROFILE_FAILURE'

const REMOVE_USER_DATA = 'Auth/REMOVE_USER_DATA'

// Initialize State
const initialState = {
  user: {},
  isLoading: true,
  error: {},
  token: '',
  isAuthenticate: false
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        isLoginLoading: true
      }
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoginLoading: false,
        isAuthenticate: true,
        user: action.payload
      }
    case LOGIN_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoginLoading: false
      }
    case LOGOUT_REQUEST:
      return {
        ...state,
        isLoginLoading: true
      }
    case LOGOUT_SUCCESS:
      return {
        ...state,
        isLoginLoading: false,
        isAuthenticate: false,
        token: ''
      }
    case LOGOUT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoginLoading: false
      }
    case EDIT_USER_PROFILE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case EDIT_USER_PROFILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        user: action.payload
      }
    case EDIT_USER_PROFILE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_CURRENT_USER_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_CURRENT_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        user: action.payload
      }
    case FETCH_CURRENT_USER_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case REMOVE_USER_DATA:
      return {
        ...state,
        user: {}
      }
    default:
      return state
  }
}

// Action Creators
export const login = (history, data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: LOGIN_REQUEST
      })
      const response = await API.post(EndPoints.HERO + `/loginWithType`, data)
      if (response.data.data.heroType != "CIRCULAR_BIN") {
        message.error('เว็บไซต์นี้สามารถใช้ได้เฉพาะฮีโร่ CIRCULAR_BIN')
        dispatch({
          type: LOGIN_FAILURE
        })
      } else {
        dispatch({
          type: LOGIN_SUCCESS,
          payload: response.data.data
        })
        localStorage.setItem('user-token', response.data.data.token)
        history.push('/')
      }
    } catch (err) {
      console.error(err)
      message.error('username and password does not match!')
      dispatch({
        type: LOGIN_FAILURE
      })
    }
  }
}

export const logout = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: LOGOUT_REQUEST
      })

      dispatch({
        type: LOGOUT_SUCCESS
      })

      dispatch({
        type: REMOVE_USER_DATA
      })

      localStorage.removeItem('user-token')
    } catch (err) {
      console.error(err)
      dispatch({
        type: LOGOUT_FAILURE
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/auth.js